import { useQuery } from 'react-query';

import { PlanUnit } from '../../types';

import { getPlanUnitDetails } from 'RestAPIs/admin';

export const useGetPlanUnitDetails = (selectedRow: PlanUnit) =>
  useQuery(['planunit', 'details'], async () => {
    return (await getPlanUnitDetails(selectedRow.brId)).data;
  });
